import {
  getApiV1ThreeLetterCodeClientAdminsClient,
  getGetApiV1ThreeLetterCodeClientAdminsClientKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodeClientAdminsClient200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 企業コード */
  threeLetterCode: string;
};

type IUseGetClientAdminsClient = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsClient200;
};

/**
 * ログイン中の管理者が所属する導入企業情報取得フック
 *
 * ご契約情報画面の各セクション（会社情報 / プラン情報 / ご担当者情報 / ご請求先情報）から
 * 共通して利用する。同一 threeLetterCode で呼び出すと SWR のキャッシュキーが一致するため、
 * 複数コンポーネントから同時にマウントされても実際のリクエストは 1 回に重複排除される。
 */
export const useGetClientAdminsClient: IUseGetClientAdminsClient = ({ threeLetterCode }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodeClientAdminsClientKey(threeLetterCode),
    () => getApiV1ThreeLetterCodeClientAdminsClient(threeLetterCode),
    { suspense: true }
  );

  return { data };
};
